import * as React from 'react'
import { graphql } from 'gatsby'
import { MDXRenderer } from 'gatsby-plugin-mdx'
import { MDXProvider } from '@mdx-js/react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import Layout from '../../components/layout'
import MDXComponents from '../../components/mdx_components'

const BlogPost: React.FC<any> = ({ data }) => {
  const image = getImage(data.mdx.frontmatter.hero_image)
  return (
    <Layout pageTitle={data.mdx.frontmatter.title}>
      <p>Posted: {data.mdx.frontmatter.date}</p>
      <div className='
        flex flex-col justify-end items-end
        rounded-lg shadow-lg overflow-hidden
        bg-slate-100 relative my-4 h-64
      '>
        <GatsbyImage
          image={image}
          alt={data.mdx.frontmatter.hero_image_alt}
          className="w-full h-full object-cover object-center absolute inset-0"
        />
        {
          data.mdx.frontmatter.hero_image_credit_link &&
          data.mdx.frontmatter.hero_image_credit_text &&
          <a
            href={data.mdx.frontmatter.hero_image_credit_link}
            target="_blank" rel="noreferrer noopener"
            className='
              inline-block rounded-lg
              bg-slate-700 text-slate-100 opacity-80 backdrop-blur-md
              hover:bg-slate-100 hover:text-slate-700 transition duration-200
              text-xs md:text-sm
              absolute px-2 md:px-3 py-1 mr-3 mb-3
            '>
            Image Credit: {data.mdx.frontmatter.hero_image_credit_text}
          </a>
        }
      </div>
      <MDXProvider components={MDXComponents}>
        <MDXRenderer>
          {data.mdx.body}
        </MDXRenderer>
      </MDXProvider>
    </Layout>
  )
}

export const query = graphql`
  query ($id: String = "") {
    mdx(id: {eq: $id}) {
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        hero_image_alt
        hero_image_credit_link
        hero_image_credit_text
        hero_image {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      body
    }
  }
`

export default BlogPost
